import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import IndexRow from "./IndexRow";

export default function IndexesTable({
  indexes,
  canDelete,
  onDelete,
  onReorder,
  onUpdateDataType,
  onUpdateLength,
  onToggleDbIndex,
  showAddRow,
  addFormRef,
  currentUserDisplayName,
  newFieldName,
  newDisplayName,
  newDataType,
  newIsDeletable,
  setNewFieldName,
  setNewDisplayName,
  setNewDataType,
  setNewIsDeletable,
  isSavingIndex,
  onSubmitNew,
  onCancelNew,
}) {
  const { t } = useTranslation();

  const [draggingIndex, setDraggingIndex] = useState(null);

  const handleDragStart = (index) => {
    setDraggingIndex(index);
  };

  const handleDragEnter = (index) => {
    if (draggingIndex === null || draggingIndex === index) return;
    onReorder(draggingIndex, index);
    setDraggingIndex(index);
  };

  const handleDragEnd = () => {
    setDraggingIndex(null);
  };

  return (
    <div className="indexes-detail-body">
      <table className="indexes-table">
        <thead>
          <tr>
            <th
              className="indexes-col-order"
              aria-label={t("admin.order", { defaultValue: "Order" })}
            />
            <th className="indexes-col-field">{t("admin.fieldLabel")}</th>
            <th className="indexes-col-type">{t("admin.dataType")}</th>
            <th className="indexes-col-created">{t("admin.createdBy")}</th>
            <th className="indexes-col-dbindex">
              {t("admin.dbIndex", { defaultValue: "Fast Search" })}
            </th>
          </tr>
        </thead>
        <tbody>
          {showAddRow && (
            <tr ref={addFormRef} className="indexes-row indexes-row--new">
              <td className="indexes-cell-order"></td>
              <td className="indexes-cell-field">
                <div className="indexes-add-field">
                  <div className="indexes-actions-group">
                    <button
                      type="button"
                      className="icon-btn indexes-row-action-btn has-tooltip"
                      disabled={!!isSavingIndex}
                      onClick={onSubmitNew}
                      title={t("admin.addIndexButton", { defaultValue: "Add index" })}
                      aria-label={t("admin.addIndexButton", { defaultValue: "Add index" })}
                    >
                      {isSavingIndex ? "…" : "+"}
                      <span className="tooltip">
                        {t("admin.addIndexButton", { defaultValue: "Add index" })}
                      </span>
                    </button>
                    <button
                      type="button"
                      className="icon-btn indexes-row-action-btn has-tooltip"
                      onClick={onCancelNew}
                      title={t("common.cancel", { defaultValue: "Cancel" })}
                      aria-label={t("common.cancel", { defaultValue: "Cancel" })}
                    >
                      &times;
                      <span className="tooltip">
                        {t("common.cancel", { defaultValue: "Cancel" })}
                      </span>
                    </button>
                  </div>
                  <input
                    className="indexes-input"
                    placeholder={t("admin.fieldPlaceholder", {
                      defaultValue: "FieldName",
                    })}
                    value={newFieldName}
                    onChange={(e) => setNewFieldName(e.target.value)}
                  />
                </div>
              </td>
              <td className="indexes-cell-type">
                <select
                  className="indexes-input"
                  value={newDataType}
                  onChange={(e) => setNewDataType(e.target.value)}
                >
                  <option value="string">{t("admin.dataTypes.string")}</option>
                  <option value="int">{t("admin.dataTypes.int")}</option>
                  <option value="datetime">
                    {t("admin.dataTypes.datetime")}
                  </option>
                  <option value="bool">{t("admin.dataTypes.bool")}</option>
                </select>
              </td>
              <td className="indexes-cell-created">
                <span className="indexes-created-by-value">
                  {currentUserDisplayName ||
                    t("admin.currentUser", { defaultValue: "Current user" })}
                </span>
              </td>
              <td className="indexes-cell-dbindex">
                <label className="indexes-new-deletable">
                  <input
                    type="checkbox"
                    checked={newIsDeletable}
                    onChange={(e) => setNewIsDeletable(e.target.checked)}
                  />
                  <span>{t("admin.deletable")}</span>
                </label>
              </td>
            </tr>
          )}
          {indexes && indexes.length > 0 ? (
            indexes.map((ix, index) => (
              <IndexRow
                key={ix.fieldName}
                index={ix}
                rowIndex={index}
                isDragging={draggingIndex === index}
                canDelete={canDelete}
                onDelete={() =>
                  onDelete(ix.fieldName, ix.createdBy, ix.isDeletable)
                }
                onUpdateDataType={onUpdateDataType ? (dt, fmt) => onUpdateDataType(ix.fieldName, dt, fmt) : undefined}
                onUpdateLength={onUpdateLength}
                onToggleDbIndex={onToggleDbIndex}
                onDragStart={() => handleDragStart(index)}
                onDragEnter={() => handleDragEnter(index)}
                onDragEnd={handleDragEnd}
              />
            ))
          ) : (
            <tr>
              <td className="indexes-empty-cell" colSpan={5}>
                {t("admin.noIndexes")}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
